import { useDealItemPicker } from '../DealItemPicker';
import { classNames } from 'libs/react';
import { ButtonStatus } from '../DealItemPicker';
import { Button } from 'components/Button';
import { React } from 'libs/react';
import './DealItemPickerPrevButton.scss';
/**
 * @component DealItemPickerPrevButton
 * @since 1.0.0
 * @hidden
 */
export function DealItemPickerPrevButton(props) {
    const { style, status } = props;
    const { gotoPrev } = useDealItemPicker();
    if (status == ButtonStatus.Hidden) {
        return null;
    }
    const className = classNames('deal-item-picker-prev-button', 'deal-item-picker-prev-button--' + style, props.className);
    const disabled = status == ButtonStatus.Disabled;
    return (React.createElement("div", { className: "deal-item-picker-tool-bar-item" },
        React.createElement(Button, { className: className, style: "plain", picto: "arrow-left", label: t('Back'), disabled: disabled, onPress: gotoPrev })));
}
